import { authHeader } from "../_helpers";
import { handleResponse } from "../_helpers/response";
import config from "../config";
export const DocumentVerificationService = {
  getVehicleDetailsByMasterId,
  getDrivingLicenseDetailsByMasterId,
  getPassportDetailsByMasterId,
  getAdhharBasicDetailsByMasterId,
  getVoterDetailsByMasterId,
  mergeDocument,
};
const baseUrl = config.apiGateway.baseUrl;

function getVehicleDetailsByMasterId(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getVehicleDetailsByMasterId/`,
    requestOptions
  ).then(handleResponse);
}
function getDrivingLicenseDetailsByMasterId(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getDrivingLicenseDetailsByMasterId/`,
    requestOptions
  ).then(handleResponse);
}
function getPassportDetailsByMasterId(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getPassportDetailsByMasterId/`,
    requestOptions
  ).then(handleResponse);
}
function getAdhharBasicDetailsByMasterId(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getAdhharBasicDetailsByMasterId/`,
    requestOptions
  ).then(handleResponse);
}
function getVoterDetailsByMasterId(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getVoterDetailsByMasterId/`,
    requestOptions
  ).then(handleResponse);
}
function mergeDocument(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/mergeDocument/`, requestOptions).then(
    handleResponse
  );
}
